(function () {
  'use strict';

  angular
    .module('journal')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('journal', {
        url: '/journal',
        templateUrl: 'journal/journal.tpl.html',
        controller: 'JournalCtrl',
        controllerAs: 'journal'
      });
  }
}());
